import React from 'react'
import { Row, Col, UncontrolledAlert, Spinner, Button } from 'reactstrap'
import { withTranslation } from 'react-i18next'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import PropTypes from 'prop-types'
import { processError } from '../../lib/lib'
import getSystemFrontendSettings from '../../lib/systemFrontendSettings'

class Login extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            username: '',
            pwd: '',
            showError: false,
            errorMessage: '',
            authorizing: false,
            loginDocs: [],
            notification: '',
            // eslint-disable-next-line no-undef
            template: process.env.REACT_APP_TEMPLATE,
        }
        this.userChange = this.userChange.bind(this)
        this.pwdChange = this.pwdChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.showHidePwd = this.showHidePwd.bind(this)
    }

    componentWillMount() {
        const lang = this.props.i18n.language
        getSystemFrontendSettings({ lang, force: true })
            .then((result) => {
                if (result) this.setState({ loginDocs: result.loginDocs, notification: result.notification })
            })
            .catch((e) => processError(e, this.props.history))
    }

    userChange(event) {
        this.setState({ username: event.target.value })
    }

    pwdChange(event) {
        this.setState({ pwd: event.target.value })
    }

    showHidePwd(event) {
        event.preventDefault()
        const input = document.getElementById('user_pass')
        const type = document.getElementById('user_pass').attributes.type.value
        const eye = document.getElementById('show_hide_password')
        if (type === 'password') {
            input.setAttribute('type', 'text')
            eye.classList.remove('fa-eye-slash')
            eye.classList.add('fa-eye')
        } else {
            input.setAttribute('type', 'password')
            eye.classList.remove('fa-eye')
            eye.classList.add('fa-eye-slash')
        }
    }

    async handleSubmit(event) {
        event.preventDefault()
        const { t } = this.props
        const cookies = new Cookies()
        this.setState({ authorizing: true })
        const userLoginOrEmailOrMobile = this.state.username
        const userPassword = this.state.pwd
        const ref = cookies.get('ref')
        if (!userLoginOrEmailOrMobile) this.setState({ showError: true, errorMessage: 'Login is required', authorizing: false })
        else if (!userPassword) this.setState({ showError: true, errorMessage: 'Password is required', authorizing: false })
        else
            api.login({ userLoginOrEmailOrMobile, userPassword, ref })
                .then(async (authorized) => {
                    const { accessToken, refreshToken, accessExpired, accessExpiredTime, isNew } = authorized.data
                    cookies.set('accessToken', accessToken, { path: '/' })
                    cookies.set('accessExpired', accessExpired, { path: '/' })
                    cookies.set('refreshToken', refreshToken, { path: '/' })
                    cookies.set('accessExpiredTime', accessExpiredTime, { path: '/' })
                    cookies.set('isNew', isNew, { path: '/' })
                    cookies.remove('ref')
                    this.setState({ authorizing: false })
                    this.props.history.push({ 
                        pathname: '/main',
                        state: { notification: true },
                    })
                })
                .catch((e) => {
                    if (!e.response) {
                        this.setState({ showError: true, errorMessage: t('server-unavailable'), authorizing: false })
                        return
                    }
                    let errorMessage = e.response.data.errorMessage
                    if (errorMessage === 'Invalid params') errorMessage = 'Incorrect login or password'
                    this.setState({ showError: true, errorMessage: errorMessage, authorizing: false })
                })
    }

    render() {
        const { t } = this.props
        return (
            <div className="position-relative">
                <UncontrolledAlert
                    isOpen={this.state.showError}
                    toggle={() => this.setState({ showError: false })}
                    className="login-error"
                    color="danger"
                >{this.state.errorMessage}</UncontrolledAlert>
                <Row className="login-row w-100 m-0">
                    <Col xl={6} lg={12} className="login-bg">
                        <div className="main-logo"></div>
                        {/* <img src={logo} alt=""></img> */}
                    </Col>
                    <Col xl={6} lg={12} className="login-form px-0">
                        <div id="login" className="login loginpage col-md-8 offset-md-2">
                            <div className="login-welcome d-flex flex-column lg-font-size">
                                <span>{t('login-welcome1')}</span>
                                <span className='font-weight-bold'>{t(`login-welcome-${this.state.template}`)}</span>
                            </div>
                            <div className="login-please md-font-size">{t('login-please')}</div>
                            <form
                                name="loginform"
                                id="loginform"
                                action="#!"
                                method="post"
                                onSubmit={this.handleSubmit}
                            >
                                <div>
                                    <label htmlFor="user_login">
                                        <span className="login-label sm-font-size">{t('login-login')}</span>
                                        <input
                                            type="text"
                                            name="log"
                                            id="user_login"
                                            className="input login-input md-font-size"
                                            value={this.state.username}
                                            onChange={this.userChange}
                                            size="20"
                                            placeholder="johndoe@gmail.com"
                                        />
                                    </label>
                                </div>
                                <div>
                                    <label htmlFor="user_pass">
                                        <div className="login-label-wrapper">
                                            <span className="login-label sm-font-size">{t('login-pwd')}</span>
                                        </div>
                                        <div className="login-password-wrapper">
                                            <input
                                                type="password"
                                                name="pwd"
                                                id="user_pass"
                                                className="input login-input md-font-size"
                                                value={this.state.pwd}
                                                onChange={this.pwdChange}
                                                size="20"
                                                placeholder="123456789"
                                            />
                                            <a
                                                href="#!"
                                                className="login-password-eye"
                                                onClick={this.showHidePwd}
                                            >
                                                <i
                                                    className="fa fa-eye-slash"
                                                    id="show_hide_password"
                                                    aria-hidden="true"
                                                ></i>
                                            </a>
                                        </div>
                                    </label>
                                </div>
                                <div className="forgetmenot">
                                    <label className="icheck-label form-label d-flex justify-content-between" htmlFor="rememberme">
                                        <div className="login-input-wrapper">
                                            <input
                                                name="rememberme"
                                                type="checkbox"
                                                id="rememberme"
                                                value="forever"
                                                className="icheck-minimal-aero"
                                            />{' '}
                                            <span className="login-remember md-font-size">
                                                {t('login-remember')}
                                            </span>
                                        </div>
                                        <div>
                                            <a href="/request-password-recovery" className="login-forgot">
                                                {t('login-forgot')}
                                            </a>
                                        </div>
                                    </label>
                                </div>
                                <div className="submit">
                                    {
                                        this.state.authorizing ?
                                            <Button variant="primary" disabled className="login-btn">
                                                <Spinner
                                                    as="span"
                                                    animation="grow"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                                <span className="pl-4 md-font-size">{t('login-authorizing')}</span>
                                            </Button>
                                            :
                                            <input
                                                type="submit"
                                                name="wp-submit"
                                                id="wp-submit"
                                                className="btn btn-primary btn-block"
                                                value={t('login-signin')}
                                            />
                                    }
                                </div>
                            </form>

                            <div id="nav" className="login-register-wrapper sm-font-size">
                                <div className='d-flex flex-column align-items-left'>
                                    <span className="login-notRegisered">
                                        {t('login-notRegistered')}
                                    </span>
                                    <div className='d-flex flex-column'>
                                        {
                                            this.state.loginDocs.map((doc, index) => {
                                                const condition = doc && typeof(doc) === 'object' && doc.title && doc.url
                                                return (
                                                    <React.Fragment key={index}>
                                                        {
                                                            condition ? 
                                                                <a style={{ color: "#7e7e7e" }} className="login-notRegisered" href={doc.url} rel='noopener  noreferrer' target="_blank">
                                                                    {doc.title}
                                                                </a> : ''
                                                        }
                                                    </React.Fragment>
                                                )
                                            })
                                        }
                                    </div>
                                    {/* <a style={{ color: "#7e7e7e" }} className="login-notRegisered" href={t('login-private-policy-link')} rel='noopener  noreferrer' target="_blank">
                                        {t('login-private-policy')}
                                    </a> */}
                                </div>
                                <a
                                    className="login-register"
                                    href="/register"
                                >
                                    {t('login-register')}
                                </a>
                            </div>
                            {/* <div className="login-social-media">
                                    <div className="login-authorize-text-wrapper">
                                        <hr className="login-authorize-text-line" />
                                        <div className="login-authorize">
                                            {t('login-authorize')}
                                        </div>
                                        <hr className="login-authorize-text-line" />
                                    </div>
                                    <div className="login-authorize-icons-wrapper">
                                        <a href="#!">
                                            <div className="login-authorize-icon-wrapper facebook-icon">
                                                <img
                                                    src={facebook}
                                                    alt=""
                                                    className="login-authorize-icon"
                                                ></img>
                                            </div>
                                        </a>
                                        <a href="#!">
                                            <div className="login-authorize-icon-wrapper tweeter-icon">
                                                <img
                                                    src={tweeter}
                                                    alt=""
                                                    className="login-authorize-icon"
                                                ></img>
                                            </div>
                                        </a>
                                        <a href="#!">
                                            <div className="login-authorize-icon-wrapper mail-icon">
                                                <img
                                                    src={mail}
                                                    alt=""
                                                    className="login-authorize-icon"
                                                ></img>
                                            </div>
                                        </a>
                                    </div>
                                </div> */}
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

Login.propTypes = {
    t: PropTypes.func,
    history: PropTypes.object,
    i18n: PropTypes.object,
}

export default withTranslation()(Login)



// WEBPACK FOOTER //
// ./src/views/Pages/Login.jsx